import React, { Component } from 'react';
import Select from 'react-select';
import OgaSelect from "../elements/OgaSelect";

export default class OrderStatusSelect extends Component {

    constructor(props) {
        super(props);
    }

    handleChange = (status) => {
        this.props.handleChange(status);
    }

    render() {
        const statuses = [
            { value: null, label: 'TODOS' },
            { value: 'DRAFT', label: 'EN BORRADOR' },
            { value: 'PRODUCT_RESERVED', label: 'CON LOTE RESERVADO' },
            { value: 'CONFIRMED', label: 'CONFIRMADA' },
            { value: 'SIGNED_CONTRACT', label: 'CONTRATO FIRMADO' }
        ];
        return (
            <OgaSelect
                bsSize="small"
                placeholder="Estado"
                value={this.props.selection}
                onChange={(status) => this.handleChange(status)}
                options={statuses}
            />
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/OrderStatusSelect/OrderStatusSelect.jsx